module.exports = __webpack_public_path__ + "img/drug-certificate.16d8c14c.jpg";